// Changed rows travel on ordinary notifications; a notification without data requests reconnect recovery.
export function refreshFt3dCurtains(encounterId?: string, curtainDelta?: Record<string, unknown>): void {
    const envelope = { type: 'ft3d-curtain-refresh-v1', encounterId, curtainDelta };
    window.dispatchEvent(new CustomEvent(envelope.type, { detail: envelope }));
    document.querySelectorAll<HTMLIFrameElement>('iframe').forEach(frame => {
        if (frame.src && new URL(frame.src, location.href).origin === location.origin) {
            frame.contentWindow?.postMessage(envelope, location.origin);
        }
    });
}
